import type { FC, ReactElement } from 'react';

import LogoButton from '../Member/components/naviagation/LogoButton';
import { cn } from '../utils/cn';
import {
  DEFAULT_MOBILE_NAVBAR_HEIGHT,
  GNB_HEIGHT_CSS_VAR,
} from '../utils/common/gnbHeight';
import { Z_INDEX } from '../utils/common/zIndex';
import usePublishElementHeight from '../utils/hook/usePublishElementHeight';

import BandBanner from './BandBanner';

const MobileGNBWrapper: FC<{
  rightButtons: ReactElement;
  isScrollGNB?: boolean;
  children?: React.ReactNode;
  visibility?: 'invisible' | 'visible';
}> = ({
  rightButtons,
  children,
  isScrollGNB = false,
  visibility = 'visible',
}) => {
  /** GNB 행 높이(스크롤 중 불변) → CSS 변수(GNB_HEIGHT_CSS_VAR)로 발행, sticky 서브헤더 top·오프셋이 구독 */
  const gnbRowRef = usePublishElementHeight(GNB_HEIGHT_CSS_VAR, {
    skipZero: true,
  });

  return (
    <>
      {/* 띠배너: 흐름 안에 두어 스크롤 시 자연히 위로 사라진다 (공간 자동 반환, 수동 spacer 불필요) */}
      <BandBanner />
      {/* GNB 행: sticky로 상단 고정. 흐름 안이므로 브라우저가 높이만큼 공간을 자동 예약한다 */}
      <div
        ref={gnbRowRef}
        className={cn('sticky top-0 bg-white', visibility)}
        style={{ zIndex: Z_INDEX.MOBILE_GNB }}
      >
        <div
          className={`flex-between px-16px ${
            isScrollGNB ? 'py-12px' : 'py-13px'
          }`}
          style={{ height: DEFAULT_MOBILE_NAVBAR_HEIGHT }}
        >
          <LogoButton />
          <div className="flex items-center gap-7px">{rightButtons}</div>
        </div>
        {children}
      </div>
    </>
  );
};

export default MobileGNBWrapper;
